import React from 'react';
import { S } from './style';
export function LinkButton({ children, handleClick, fontSize, color }) {
    return (<S.Layout color={color} fontSize={fontSize} onClick={handleClick}>
      {children}
    </S.Layout>);
}
